<template>
	<div class="medication_item" @click="onClick">
		<div class="medication_item_content">
			<div class="content">
				<div class="title">{{title}}</div>
				<!-- <div class="label_row">
					<div class="label">每次剂量：</div>
					<div class="text">{{dosage}}</div>
				</div> -->
				<div class="label_row" v-if="time&&time.length>0">
					<div class="label">提醒时间：</div>
					<div class="text">{{times}}</div>
				</div>
				<div class="label_row" v-if="remarks">
					<div class="label">备注：</div>
					<div class="text">{{ remarks }}</div>
				</div>
			</div>
			<div class="left_button" v-if="status">
				<div class="button_item" :class="status">
					<div class="icon"><van-icon :name="statusObj[status].icon" /> </div>
					<div> {{statusObj[status].text}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'medicationItem',
    props: {
        status: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        dosage: {
            type: [String, Number],
            default: ''
        },
        time: {
            type: Array,
            default: () => []
        },
        remarks: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            statusObj: {
                error: {
                    text: '漏服药',
                    icon: 'warning'
                },
                warning: {
                    text: '未标记',
                    icon: 'warning'
                },
                success: {
                    text: '已服药',
                    icon: 'checked'
                }
            }
        }
    },
    computed: {
        times () {
            return this.time && this.time.join('、')
        }
    },
    methods: {
        onClick () {
            this.$emit('onClick')
        }
    }
}
</script>
<style lang="less" scoped>
.medication_item {
	border-radius: 16px;
	overflow: hidden;
	margin-bottom: 24px;
	&_content {
		border-left: 12px solid @primary;
		display: flex;
		padding: 32px 28px;
		background-color: #ffffff;
		.content {
			flex: 1;
			.title {
				color: #1f2329;
				font-size: 32px;
				vertical-align: baseline;
				font-weight: bold;
				margin-bottom: 16px;
				span {
					font-size: 28px;
				}
			}
			.label_row {
				display: flex;
				font-size: 26px;
				margin-bottom: 12px;
				color: #1f2329;
				.label {
					color: #8f959e;
					width: 155px;
					text-align: right;
				}
				.text {
					flex: 1;
				}
			}
			.label_row:last-child {
				margin-bottom: 0;
			}
		}
		.left_button {
			width: 158px;
			margin-left: 12px;
			display: flex;
			align-items: flex-end;
			.button_item {
				width: 158px;
				height: 60px;
				border-radius: 12px;
				color: #ffffff;
				font-size: 24px;
				display: flex;
				align-items: center;
				justify-content: center;
				.icon {
					margin-right: 6px;
				}
			}
			.error {
				background-color: @danger;
			}
			.warning {
				background-color: @warning;
			}
			.success {
				background-color: @primary;
			}
		}
	}
}
</style>